import styled from 'styled-components'

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100vw;
  background-color: ${props => props.bgColor};
`

export const HomeStickyContainer = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0; /* Make sure it sticks to the top */
  height: 100vh; /* Full height for sticky sidebar */
`

export const HomeSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto; /* Use auto to handle content overflow */
  width: 100%;
  background-color: ${props => props.bgColor};
  padding: 20px; /* Add padding for spacing */
`

export const BannerImageContainer = styled.div`
  background-image: url('https://assets.ccbp.in/frontend/react-js/nxt-watch-banner-bg.png');
  background-size: cover;
  background-position: center; /* Center the background image */
  display: ${props => props.display};
  flex-direction: column; /* Change direction for better layout */
  align-items: center; /* Center items */
  justify-content: center; /* Center items */
  width: 100%; /* Full width */
  height: 200px; /* Adjust height */
  padding: 20px; /* Padding for spacing */
  position: relative; /* For positioning close button */
`

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px; /* Space between items */
  max-width: 600px; /* Limit width */
  width: 100%; /* Full width */
`

export const BannerImage = styled.img`
  object-fit: contain; /* Maintain aspect ratio */
  width: 200px; /* Adjust width */
  height: auto; /* Keep aspect ratio */
`

export const BannerText = styled.p`
  color: #181818;
  font-family: 'Roboto', sans-serif; /* Correct font-family syntax */
  font-size: 18px; /* Adjust font size */
  margin: 0; /* Remove default margin */
`

export const GetItNowButton = styled.button`
  background-color: transparent;
  border: 2px solid #181818; /* Make border thicker */
  padding: 10px 20px; /* Adjust padding */
  color: #181818;
  width: auto; /* Adjust width */
  cursor: pointer;
  font-size: 16px; /* Adjust font size */
  border-radius: 5px; /* Rounded corners */
  transition: background-color 0.3s, color 0.3s; /* Smooth transition */
  
  &:hover {
    background-color: #181818; /* Change background on hover */
    color: #fff; /* Change text color on hover */
  }
`

export const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  position: absolute;
  top: 10px;
  right: 10px; /* Position close button */
  outline: none;
  cursor: pointer;
  border-radius: 50%; /* Round button */
  padding: 5px;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.1); /* Subtle hover effect */
  }
`
